import { createSelector } from '@reduxjs/toolkit';
// "old" medias reducer
const mediasReducer = (state) => state.medias;
export const mediasDataSelector = createSelector(mediasReducer, (medias) => medias.resources);
// redux medias reducer
const reduxMediasReducer = (state) => state.reduxMedias;
export const reduxMediasDataSelector = createSelector(reduxMediasReducer, (reducer) => reducer.data);
